import Preview from './Preview';

export default Preview;



// WEBPACK FOOTER //
// ./src/components/admin/Preview/index.js